import { render, staticRenderFns } from "./TaskTimeConfig.vue?vue&type=template&id=715a288e&scoped=true&"
import script from "./TaskTimeConfig.vue?vue&type=script&lang=js&"
export * from "./TaskTimeConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "715a288e",
  null
  
)

export default component.exports